/**
 * @generated SignedSource<<50293afa8fb8346d24b79c83d0af31c7>>
 * @relayHash 8904e913edda3cb40e28ffebe81b1fb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4366d3403c313f6b51e48e84f6ccaf716bf1b641c83d1fd913305d7e8767a790

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "helpCenterAri"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v2 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "helpCenterAri"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "__typename"
    },
    v4 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "HelpCenterHomePageLayout",
        "kind": "LinkedField",
        "name": "homePageLayout",
        "plural": false,
        "selections": [{
          "concreteType": "HelpCenterLayoutAdf",
          "kind": "LinkedField",
          "name": "layoutAdf",
          "plural": false,
          "selections": [{
            "concreteType": "HelpCenterLayoutAdfContentConnection",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [{
              "concreteType": "HelpCenterLayoutAdfContentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "concreteType": "HelpCenterLayoutAdfContent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "name": "content"
                }]
              }]
            }]
          }]
        }]
      }],
      "type": "HelpCenter"
    },
    v5 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "message"
      }],
      "type": "QueryError"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "hubHomeQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v4 /*: any*/, v5 /*: any*/]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hubHomeQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "id"
            }],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }]
    },
    "params": {
      "id": "4366d3403c313f6b51e48e84f6ccaf716bf1b641c83d1fd913305d7e8767a790",
      "metadata": {},
      "name": "hubHomeQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "fb0671109e961af05dfd93621bc9b5e0";
export default node;